import React from "react";
import { Button, notification } from "antd";
import { useForgotPasswordMutation } from "store/api";
import { ErrorAlert, Logo } from "components/Common";
import InputField from "components/Common/InputField";
import { Formik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();
  const [error, setError] = React.useState<string | null>(null);
  const onFinish = async (values: any) => {
    try {
      await forgotPassword(values).unwrap();
      notification.success({
        message: "Please check your email inbox, reset link is sent",
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error: any) {
      setError(
        error?.data?.error || "Failed to send reset link. Please try again.",
      );
    }
  };

  return (
    <div className="w-full h-full flex items-center justify-center">
      <div className="w-full h-full flex flex-col justify-center">
        <Logo />
        <h1 className="text-2xl font-bold mb-1 text-center">Forgot Password</h1>
        <p className="mb-4 text-center">
          Enter your email to reset your password
        </p>

        <Formik
          validateOnBlur
          initialValues={{
            email: "",
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email("Invalid email address")
              .required("Email is required"),
          })}
          onSubmit={async (values) => {
            await onFinish(values);
          }}
        >
          {({ handleSubmit, isValid, dirty }) => (
            <form onSubmit={handleSubmit} className="space-y-3">
              <ErrorAlert type="error" message={error} setMessage={setError} />
              <InputField
                label="Email"
                name="email"
                type="email"
                placeholder="Enter email"
              />

              <Button
                type="primary"
                htmlType="submit"
                className="w-full h-10"
                loading={isLoading}
                disabled={!isValid || !dirty || isLoading}
              >
                Send Reset Link
              </Button>
            </form>
          )}
        </Formik>
        <div className="flex items-center justify-end p-3 gap-2">
          <Link to="/" className="text-blue-500">
            Back to login
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
